import { render, staticRenderFns } from "./TitleToolbar_deprecated.vue?vue&type=template&id=77bf4b44&scoped=true&"
import script from "./TitleToolbar_deprecated.vue?vue&type=script&lang=js&"
export * from "./TitleToolbar_deprecated.vue?vue&type=script&lang=js&"
import style0 from "./TitleToolbar_deprecated.vue?vue&type=style&index=0&id=77bf4b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf4b44",
  null
  
)

export default component.exports